import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import MouseContextProvider from "./context/mouseContext";
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <MouseContextProvider>
      <App />
    </MouseContextProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorkerRegistration.register();
